module.exports = __webpack_public_path__ + "media/images/social-instagram-bc7ab04c276a50fcdd075105c089b26b.svg";